import { fork, all } from 'redux-saga/effects'

import authenticationSaga from './authentication'
import errorSaga from './error'
import passwordSaga from './password'
import profileSaga from './profile'
import progressSaga from './progress'
import roleSaga from './role'
import routerSaga from './router'
import userSaga from './user/user'
import userCreateSaga from './user/userCreate'
import userDetailSaga from './user/userDetail'
import userEditSaga from './user/userEdit'
import bankSaga from './bank/bank'
import bankDetailSaga from './bank/bankDetail'
import bankEditSaga from './bank/bankEdit'
import corporateSaga from './corporate/corporate'
import corporateCreateSaga from './corporate/corporateCreate'
import corporateDetailSaga from './corporate/corporateDetail'
import corporateEditSaga from './corporate/corporateEdit'
import campaignSaga from './campaign/campaign'
import campaignCreateSaga from './campaign/campaignCreate'
import campaignDetailSaga from './campaign/campaignDetail'
import campaignEditSaga from './campaign/campaignEdit'
import fileSaga from './file/file'
import plickSaga from './file/plick'
import plickDetailSaga from './file/plickDetail'
import contoCorrenteSaga from "./contoCorrente/contoCorrente";
import contoCorrenteCreateSaga from "./contoCorrente/contoCorrenteCreate";
import contoCorrenteEditSaga from "./contoCorrente/contoCorrenteEdit";
import IndexSaga from "./Index";
import FileHistory from "./file/history";
import reportSaga from "./report"
import authNavbarSaga from "./authNavbar"

export default function* rootSaga() {
  yield all([
    fork(fileSaga),
    fork(authenticationSaga),
    fork(errorSaga),
    fork(passwordSaga),
    fork(profileSaga),
    fork(progressSaga),
    fork(roleSaga),
    fork(routerSaga),
    fork(userSaga),
    fork(userCreateSaga),
    fork(userDetailSaga),
    fork(userEditSaga),
    fork(bankSaga),
    fork(bankDetailSaga),
    fork(bankEditSaga),
    fork(corporateSaga),
    fork(corporateCreateSaga),
    fork(corporateDetailSaga),
    fork(corporateEditSaga),
    fork(campaignSaga),
    fork(campaignCreateSaga),
    fork(campaignDetailSaga),
    fork(campaignEditSaga),
    fork(plickSaga),
    fork(plickDetailSaga),
    fork(contoCorrenteSaga),
    fork(contoCorrenteCreateSaga),
    fork(contoCorrenteEditSaga),
    fork(IndexSaga),
    fork(FileHistory),
    fork(reportSaga),
    fork(authNavbarSaga)
  ]);
}